/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';
// import { NestedUser } from '@habity/types';
// import { createStore } from 'zustand';
import { persist } from 'zustand/middleware';
import { create } from 'zustand';

export interface UserProps {
  // user: NestedUser | null;

  consentBannerVisible?: boolean;
}

export interface UserState extends UserProps {
  // setUser: (user: NestedUser | null) => void;

  setConsentBannerVisible: (consentBannerVisible: boolean) => void;
}

export type UserStore = ReturnType<typeof useUserStore>;

// export const createUserStore = (initProps?: Partial<UserProps>) => {
//   const DEFAULT_PROPS: UserProps = {
//     user: null,
//     consentBannerVisible: true,
//   };
//   return createStore<UserState>()(
//     persist(
//       (set) => ({
//         ...DEFAULT_PROPS,
//         ...initProps,
//         setUser: (user: NestedUser | null) => set({ user }),
//         setConsentBannerVisible: (consentBannerVisible: boolean) =>
//           set({ consentBannerVisible }),
//       }),
//       {
//         name: 'habity-user-old',
//       }
//     )
//   );
// };

export const UserContext = createContext<UserStore | null>(null);

const DEFAULT_PROPS: UserProps = {
  // user: null,

  consentBannerVisible: true,
};

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      ...DEFAULT_PROPS,
      // setUser: (user: NestedUser | null) => set({ user }),

      setConsentBannerVisible: (consentBannerVisible: boolean) =>
        set({ consentBannerVisible }),
    }),
    {
      name: 'habity-user',
    }
  )
);
